<template>
  <div class="lr-ty-popup">
    <div>
      <!-- HEADER -->
      <div class="popup-header">
        <div class="popup-header-logo">
          <img
            class="popup-logo"
            src="https://www.wwf.org.au/ecThemes/3/Images/WWF-RA-lockup-logo.svg"
          />
        </div>

        <div>
          <button class="popup-close-button" data-close type="button" @click="handleClose">
            <span class="popup-close-button-span">Close</span>
          </button>
        </div>
      </div>

      <div class="wwf-content" ref="stepup">
        <h3>{{ title }}</h3>
        <div v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "leaf-relief-thank-you-popup",

  props: {
    // Content
    title: {
      type: String,
    },
    content: {
      type: String,
    },
  },

  computed: {},

  watch: {},

  created: function () {},
  mounted() {
    // Attach amplitude event to hyperlink button in content
    const stepupButton = this.$refs.stepup.querySelector("a");
    try {
      $(stepupButton).click({ callback: this.handleClick }, function (e) {
        e.preventDefault();
        e.data.callback(this.href);
      });
    } catch (err) {
      console.error(err);
    }
  },

  methods: {
    handleClose() {
      this.$store.dispatch("logStepUpDeclined");
    },
    handleClick(link) {
      this.$store.dispatch("logStepUpActioned", link)
      .then(() => window.location.href = link);
    }
  },
};
</script>

<style scoped>
/* WWF */
.wwf-content {
  margin-bottom: 20px;
}

#reveal-popup-custom-content .wwf-content h3 {
  margin-top: 120px;
  text-align: center;
}

#reveal-popup-custom-content .wwf-content h3::before {
  left: 50%;
  transform: translateX(-50%);
}

#reveal-popup-petition-message .popup-header-logo,
#reveal-popup-custom-content .popup-header-logo {
  height: unset;
  padding: unset;
}

.wwf-popup img.popup-logo {
  width: unset;
}
</style>


// WEBPACK FOOTER //
// ThankYouPopup.vue?43c66702